<template>
    <div class="row">
    <div class="col-md-2 mb-3">
        <div class="biolink-btn">
            <router-link v-if="user.level === 1" class="w-100 btn btn-new btn-upp bdr-15 mr-2" :to="{ name: 'event' }">
                <i class="uil uil-arrow-left"></i> Back to Event
            </router-link>
            <router-link v-if="user.level === 3" class="w-100 btn btn-new btn-upp bdr-15 mr-2" :to="{ name: 'agent-event' }">
                <i class="uil uil-arrow-left"></i> Back to Event
            </router-link>
        </div>
    </div>
    <div class="col-md-8">
        <b-card class="card-t-bio bdr-15">
            <div class="biolink-wrapper d-flex align-items-center" @click="show_link = !show_link">
                <div class="t-bio-nm" v-if="detail_event.slug">
                    <strong class="border-right pr-2 mr-2">Event ID: </strong> {{detail_event.id}}
                    <strong>Event Name: </strong> {{detail_event.title}}
                </div>
                <div class="t-bio-link pt-1 ml-auto">
                    <i :class="show_link ===  false ? 'uil uil-angle-down' : 'uil uil-angle-up'"></i>
                </div>
            </div>
            <div class="biolink-body pt-3" v-if="show_link === true">
                <div class="bl-item d-flex align-items-center">
                    <div class="bl-link">
                        <strong>Event Link : </strong>
                        <input type="hidden" id="biolink" :value="$options.filters.bioLink(detail_event)">
                    </div>
                    <div class="bl-act ml-2">
                        <a href="#" v-on:click.prevent="openBioLink(detail_event)" class="act mr-2">Visit</a>
                        <a href="#" @click.stop.prevent="copyBioLink()" class="act">Copy</a>
                    </div>
                </div>
                <div class="bl-item d-flex align-items-center mt-3 position-relative">
                    <div class="bl-link">
                        <strong>Event Analytics:</strong>
                        <input type="hidden" id="analyticslink" :value="$options.filters.AnalyticsLink(detail_event)">
                    </div>
                    <div class="bl-act ml-2">
                        <a href="#" v-on:click.prevent="openAnalyticsLink(detail_event)" class="act mr-2 position-relative">
                            <div v-if="detail_event.type === 'STANDARD'" class="disabled-feature bdr-15 btn-m" @click.prevent="$emit('alertPackage')">
                                <i class="uil uil-lock-alt"></i>
                            </div>
                            Visit
                        </a>
                        <a href="#" @click.stop.prevent="copyAnalyticsLink()" class="act position-relative">
                            <div v-if="detail_event.type === 'STANDARD'" class="disabled-feature bdr-15 btn-m" @click.prevent="$emit('alertPackage')">
                                <i class="uil uil-lock-alt"></i>
                            </div>
                            Copy
                        </a>
                    </div>
                </div>
            </div>
        </b-card>
    </div>
    <div class="col-md-2 mb-3">
        <div class="biolink-btn">
            <button @click.prevent="alertStatusEvents(detail_event)" class="w-100 btn btn-new3 btn-upp bdr-15 mr-2">
                <i style="font-size: 20px;vertical-align: middle;" class="uil uil-check-circle"></i> Publish Event
            </button>
        </div>
    </div>
</div>
</template>

<script>
    import { mapState, mapActions} from 'vuex'

    export default {
        data(){
            return{
                window_width:0,
                show_link:false,
            }
        },
        computed : {
            ...mapState('AuthControl', {
                user: state => state.user,
            }),
        },
        props:{
            detail_event:{
                type: Object,
                required: true,
            },
        },
        created(){
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        filters: {
            truncate: function(string, value) {
                if(string.length < value){
                    return string;
                }else{
                    return (string || '').substring(0, value) + '…';
                }
            },
            bioLink: function(value) {
                var frameURL;
                if(process.env.NODE_ENV == 'development'){
                    frameURL = 'http://localhost:3000/'
                }else if(process.env.NODE_ENV == 'production'){
                    frameURL = window.location.origin.replace('app.','') + '/'
                }
                return frameURL + value.id + '/' + value.slug
            },
            AnalyticsLink: function(value) {
                var frameURL;
                if(process.env.NODE_ENV == 'development'){
                    frameURL = 'http://localhost:3000/'
                }else if(process.env.NODE_ENV == 'production'){
                    frameURL = window.location.origin.replace('app.','') + '/'
                }
                return frameURL + value.id + '/' + value.slug + '/analytics?code=' + value.token_analytics
            },
        },
        methods:{
            ...mapActions('EventsControl', ['changeStatusEvent']),

            alertStatusEvents:function(data){
                var text = '';
                var sts = null;

                if(data.status === 0){
                    text = 'Are you sure you publish event ' + data.title + ' ? This action cannot be undone'
                    sts = 1
                }

                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: text,
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.changeStatusEvent({id:data.id,status:sts})
                        if(this.user.level === 1){
                            this.$router.push({ name: 'event' })
                        }else if(this.user.level === 3){
                            this.$router.push({ name: 'agent-event' })
                        }

                    }
                })
            },
            handleResize() {
                this.window_width = window.innerWidth;
            },
            openBioLink: function(value){
                var frameURL;
                if(process.env.NODE_ENV == 'development'){
                    frameURL = 'http://localhost:3000/'
                }else if(process.env.NODE_ENV == 'production'){
                    frameURL = window.location.origin.replace('app.','') + '/'
                }
                var url =  frameURL + value.id + '/' + value.slug
                window.open(url)
            },
            openAnalyticsLink: function(value){
                if(this.detail_event.type === 'STANDARD'){
                    return
                }
                var frameURL;
                if(process.env.NODE_ENV == 'development'){
                    frameURL = 'http://localhost:3000/'
                }else if(process.env.NODE_ENV == 'production'){
                    frameURL = window.location.origin.replace('app.','') + '/'
                }
                var url =  frameURL + value.id + '/' + value.slug + '/analytics?code=' + value.token_analytics
                window.open(url)
            },
            copyBioLink () {
                let bioLinkToCopy = document.querySelector('#biolink')
                bioLinkToCopy.setAttribute('type', 'text')
                bioLinkToCopy.select()

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'Berhasil' : 'Gagal';
                    this.$toast.success( msg + ' Disalin')
                } catch (err) {
                    this.$toast.warning( 'Maaf, text tidak bisa disalin')
                }

                bioLinkToCopy.setAttribute('type', 'hidden')
                window.getSelection().removeAllRanges()
            },
            copyAnalyticsLink () {
                if(this.detail_event.type === 'STANDARD'){
                    return
                }
                let AnalyticsLinkToCopy = document.querySelector('#analyticslink')
                AnalyticsLinkToCopy.setAttribute('type', 'text')
                AnalyticsLinkToCopy.select()

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'Berhasil' : 'Gagal';
                    this.$toast.success( msg + ' Disalin')
                } catch (err) {
                    this.$toast.warning( 'Maaf, text tidak bisa disalin')
                }

                AnalyticsLinkToCopy.setAttribute('type', 'hidden')
                window.getSelection().removeAllRanges()
            },
        }
    }

</script>

<style scoped>
    .biolink-wrapper{
        cursor: pointer;
    }
    .t-bio-link i{
        font-size: 25px;
    }
    .biolink-body{
        border-top: 1px solid #dee2e6;
        margin-top: 10px;
    }
    .bl-act .act{
        border: 1px solid #dee2e6;
        padding: 4px 15px;
        border-radius: 30px;
        color: #71757d;
        text-decoration: none;
    }
</style>